{
  "appType": "website-viewer",
  "assetsUrl": "https://wbp-dashboard.va-endpoint.com/",
  "standaloneBaseUrl": "https://app.visitor-analytics.io/",
  "translationsUrl": "https://cdn.twipla.com/translations/dashboard",
  "announcementModalApiUrl": "https://www.twipla.com/api/v1/inapp/bubbles/index.php",
  "announcementBannerApiUrl": "https://www.twipla.com/api/v1/inapp/banners/index.php",
  "dashboardTilesApiUrl": "https://www.twipla.com/api/v1/inapp/tiles/",
  "wixAppId": "13ee53b4-2343-b641-c84d-056d2e6ed2e6",
  "wixBaseUrl": "https://dashboard.va-endpoint.com/",
  "apiUrl": "https://lb-api.visitor-analytics.io/api",
  "aiApiUrl": "https://ai.twipla.com",
  "gatewayApiUrl": "https://api-gateway.visitor-analytics.io",
  "paddleVendorId": 122665,
  "paddleSandbox": false,
  "wixIgnoreVisitsUrl": "https://loadbalancer.visitor-analytics.io/worker-messages",
  "reCaptchaSiteKey": "6LeN9dkUAAAAAJn80caMCZcQf3LTdceByXtTeQhF",
  "statsOverviewReleaseDate": 1577836800,
  "chatwootToken": "6PKafZ6wwTAdrR3FgDUzxnq3",
  "env": "prod",
  "surveysUrl": "https://surveys.visitor-analytics.io",
  "firstPromoter": {
    "apiUrl": null,
    "apiKey": null,
    "wId": null
  },
  "competitionReleaseDate": 1596319200,
  "supportedLanguages": [
    "en",
    "de",
    "es",
    "pt",
    "it",
    "fr",
    "ro"
  ],
  "customDomain": ".visitor-analytics.io",
  "maintenancePeriods": [
    [
      "2024-12-06T03:30:00.000Z",
      "2024-12-06T05:30:00.000Z"
    ],
    [
      "2024-11-06T03:30:00.000Z",
      "2024-11-06T05:30:00.000Z"
    ]
  ],
  "flagSmithEnvironmentId": "Txqa9mNe6JWD9Lnya34BRR",
  "sourceTag": "3.55.1-2"
}
